<div class="flex items-center justify-between">
    <p class="text-base">Enviando títulos</p>
    <mat-spinner [diameter]="20"></mat-spinner>
</div>
